import type { User } from '@/types/auth';
import { RoleEnum } from '@/types';
import { hasPermission, Permission } from './permissions';

export const isSupportShiftReadonlyViewer = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.SUPPORT_SHIFTS_READ)
  && !hasPermission(user, Permission.SUPPORT_SHIFTS_MANAGE);

export const hasSupportShiftFullAccess = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.SUPPORT_SHIFTS_MANAGE);

export const hasExceptionalSupportShiftAccess = (
  user: User | null | undefined,
): boolean => user?.role === RoleEnum.CLIENT_MANAGER
  || isSupportShiftReadonlyViewer(user) || hasSupportShiftFullAccess(user);
